import { useContext } from "react";
import AbacContext from "../context";

const useAbac = () => useContext(AbacContext);

export default useAbac;
